import BottomBlocks from './BottomBlocks'

export default BottomBlocks
